import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import Illustration from '../../Illustration';
import TimecardCard from './TimecardCard';
import { selectTimecardsList } from '../../../store/selectors';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes,
} from 'components/admin/Help';

const styles = theme => ({
  root: {
  },

});

const TimecardsCards = ({ classes, timecards, handleEdit, startEditAdmin }) => {
  return(
    <div className={classes.root}>
      {timecards.length > 0 &&
        timecards.map((timecard, i) => {
          return (

              <TimecardCard
                key={i}
                timecard={timecard}
                handleEdit={(timecard) => {
                  handleEdit(timecard);
                }}
              />

          )
        })
      }
      {timecards.length === 0 &&
        <Illustration
          title="Hmm, no Time Cards..."
          imgKey="time_management_amber"
          explainerText="Either you've not entered any or your filter had no results."
          addItemText="Enter a new Time Card by clicking the 'Floating Action Button' at top right."
        />
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { project } = props;

  return {
    timecards: selectTimecardsList(state, project),
  };
};


export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(TimecardsCards);



// WEBPACK FOOTER //
// ./src/components/admin/Timecards/TimecardsCards.jsx